goog.provide('el8.data.testCenters');

goog.require('el8.model.base');
goog.require('el8.util.string');

// BiDiLabs: this will be enventually deprecated. The new model is el8.data.LabVendorPatientSite.
// Note: this is used the the LabResult FE model

(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addStringProperty('phone');
    _class.addStringProperty('fax');

    _class.addStringProperty('address');
    _class.addStringProperty('suite');
    _class.addStringProperty('city');
    _class.addStringProperty('state');
    _class.addStringProperty('zip');
    _class.addStringProperty('addressLine');
    _class.addStringProperty('cityStateZip');

    _class.addIntProperty('companyId');
    // _class.addStringProperty('companyName'); // only including this in print json, to avoid a very frequent join
    _class.addStringProperty('locationName');

    _class.addStringProperty('labFacilityMnemonic');
    _class.addStringProperty('labFacilityDirector');

    el8.data.testCenters.lab = (function() {

        var that = new el8_EntitySet({
            model: function(spec) { return new _class(spec); }
        });

        that.loadByCompanyId = function(companyId) {
            var results = [];
            $.el8_ajax({
                type: 'GET',
                async: false,
                url: el8.service.urls.get('labCentersByCompany', [companyId]),
                success: function(data) {
                    results = that.create(data, true);
                }
            });
            return results;
        };

        return that;

    })();

    el8.data.testCenters.labResult = (function() {

        return new el8_EntitySet({
            model: function(spec) { return new _class(spec); },
            sortFn: function(a, b) {
                return el8.util.string.cmp(a.getLocationName(), b.getLocationName());
            }
        });

    })();

})();




